<template>
  <div class="s0-raiz">
  <div v-if="abierto" class="s0-fondo" @click.self="cancelar">
    <div class="s0-tarjeta" role="dialog" aria-modal="true" aria-labelledby="s0-titulo">
      <div class="s0-donde">{{ donde }}</div>
      <h3 id="s0-titulo" class="s0-titulo">La segunda de esta línea sale a 0 €</h3>
      <p class="s0-texto">
        <b>{{ lineaTexto }}</b>. {{ motivo }}, así que si hace falta segunda se hará sin cobrarla.
      </p>

      <div class="s0-campos">
        <label class="s0-campo">
          <span>% de la primera</span>
          <input type="number" min="0" step="0.01" placeholder="p. ej. 50" :value="porc"
            :disabled="bloqueado" @input="alEscribirPorc($event.target.value)">
        </label>
        <label class="s0-campo">
          <span>o importe fijo (€)</span>
          <input type="number" min="0" step="0.01" placeholder="importe" :value="importe"
            @input="alEscribirImporte($event.target.value)">
        </label>
      </div>
      <div v-if="propuesta" class="s0-pista">Propuesto por la {{ propuesta.origen }}.</div>
      <div v-if="bloqueado" class="s0-pista">El % de segunda de este servicio está bloqueado: pon un importe fijo.</div>

      <div v-if="incluible" class="s0-aviso s0-aviso-incluible">
        Este servicio tiene activado «Segundas incluidas en la primera» en su ficha: puedes dejar esta segunda
        incluida en la primera, a 0 €, o ponerle precio.
      </div>
      <!-- §9 · Por qué no se deja a 0 € sin más, quién lo autoriza y dónde: junto a los controles. Las dos
           salidas a 0 € (#1206 por el servicio, #1142 por autorización) se cuentan sin contradecirse. -->
      <div class="s0-aviso">
        <template v-if="incluible">Además, se puede dejar a 0 € por excepción con autorización</template>
        <template v-else>
          Las segundas inspecciones se facturan aparte (Dirección, 27/10/2026), así que no se dejan a 0 € sin más.
          <template v-if="incluible === null">Comprobando en la ficha del servicio si sus segundas pueden ir incluidas en la primera…</template>
          <template v-else>Si este servicio debe llevar sus segundas incluidas en la primera, lo activa un administrador en la
          ficha del servicio (Servicios), en el campo «Segundas incluidas en la primera».</template>
          Si el cliente exige esta segunda sin cobrarla, se puede dejar a 0 € por excepción con autorización</template>:
        la autoriza <b>{{ quienAutoriza }}</b> en <b>{{ dondeSeResuelve }}</b>.
        <template v-if="!contextoValido">{{ porQueNoSePideSinDocumento }}</template>
        <template v-else-if="cargando"> Consultando si ya está pedida…</template>
        <template v-else-if="errorEstado"> No se ha podido consultar si ya está pedida ({{ errorEstado }}): {{ salidaSinAutorizacion }} o vuelve a intentarlo más tarde.</template>
        <template v-else-if="situacion == 'PENDIENTE'">
          Ya está pedida<template v-if="solicitud && solicitud.nombreSolicitante"> por {{ solicitud.nombreSolicitante }}</template><template v-if="solicitud && solicitud.fechaSolicitud"> el {{ fecha(solicitud.fechaSolicitud) }}</template>
          y sigue <b>pendiente</b>. Hasta que la autoricen, la línea no se guarda a 0 € por esta vía: {{ salidaSinAutorizacion }}, o cancela y vuelve
          cuando te llegue la decisión por la campana y por correo.
        </template>
        <template v-else-if="situacion == 'RECHAZADA'">
          <b>Rechazada</b><template v-if="solicitud && solicitud.nombreResolutor"> por {{ solicitud.nombreResolutor }}</template><template v-if="solicitud && solicitud.fechaResolucion"> el {{ fecha(solicitud.fechaResolucion) }}</template><template v-if="solicitud && solicitud.motivoResolucion">: «{{ solicitud.motivoResolucion }}»</template>.
          {{ salidaSinAutorizacion.charAt(0).toUpperCase() + salidaSinAutorizacion.slice(1) }}<template v-if="estado && estado.sePuedePedir">, o vuelve a pedirla con otro motivo</template>.
        </template>
        <template v-else-if="estado && !estado.sePuedePedir && estado.motivoNoSePuedePedir"> {{ estado.motivoNoSePuedePedir }}</template>
      </div>

      <div v-if="pidiendo" class="s0-pedir">
        <label class="s0-campo">
          <span>Motivo (lo lee quien lo autoriza)</span>
          <textarea rows="3" maxlength="500" v-model="motivoPeticion" placeholder="p. ej. el cliente la exige incluida en su contrato"></textarea>
        </label>
        <div class="s0-botones">
          <button type="button" class="s0-boton" :disabled="enviando" @click="pidiendo = false">Volver</button>
          <button type="button" class="s0-boton s0-boton-pedir" :disabled="enviando || !motivoPeticion.trim()" @click="enviarPeticion">
            {{ enviando ? 'Enviando…' : 'Enviar la solicitud' }}
          </button>
        </div>
        <div v-if="!motivoPeticion.trim()" class="s0-motivo">Escribe el motivo para enviarla.</div>
        <div v-if="errorPeticion" class="s0-error">{{ errorPeticion }}</div>
      </div>

      <div v-else class="s0-botones">
        <button type="button" class="s0-boton" @click="cancelar">Cancelar</button>
        <button v-if="incluible" type="button" class="s0-boton" @click="dejarIncluida">Incluida en la primera</button>
        <!-- Solo si se puede pedir y hay quien la resuelva (§9): si no, el aviso de arriba dice por qué. -->
        <button v-if="sePuedePedir" type="button" class="s0-boton s0-boton-pedir" @click="empezarPeticion">Dejar a 0 € y pedir autorización</button>
        <button type="button" class="s0-boton s0-boton-ok" :disabled="!!motivoNoSigue" @click="ponerPrecio">Poner precio</button>
      </div>
      <div v-if="enviada" class="s0-enviada">
        Solicitud enviada a {{ quienAutoriza }}. Te avisarán por la campana y por correo; mientras tanto la línea no se
        guarda a 0 €.
      </div>
      <div v-if="motivoNoSigue && !pidiendo" class="s0-motivo">{{ motivoNoSigue }}</div>
    </div>
  </div>
  </div>
</template>

<script>
import { propuestaDe, motivoACero, descuentoTotal, lineaParaPedir, autorizadaEnLinea } from '../js/segundaACero.js';
import Autorizaciones from '../js/db/Autorizaciones.js';
import Servicio from '../js/db/Servicio.js';
import { AUTORIZADORES_POR_DEFECTO } from '../js/condicionesFacturacion.js';

/**
 * Aviso P11 de la #907: la segunda de una línea sale a 0 €. Lo usan la oferta, el alta del pedido y
 * la creación de la línea de segunda. `pedir(linea, donde, contexto)` devuelve una promesa con:
 * - el precio que ha puesto el comercial (`{ porcSegunda }` o `{ importeSegunda }`);
 * - `{ aCero: true }` si la línea puede seguir a 0 € sin preguntar: su segunda está autorizada en
 *   OEE › Autorizaciones o el cliente es interno de SIMECAL (#1142). La API lo vuelve a comprobar;
 * - o `null` si cancela, también después de pedir la autorización: mientras está pendiente, la línea
 *   no se guarda a 0 €.
 *
 * `contexto` es `{ documento: 'OFERTA' | 'PEDIDO', id, original? }`: la autorización se pide para una
 * línea de un documento guardado. Sin él (una oferta nueva) no hay botón y el aviso dice por qué.
 * `original` es la línea del documento si lo que se avisa es una copia suya (el editor de la oferta):
 * la clave que dé la API va también a ella, para que cancelar el editor no la pierda.
 *
 * «Dejar a 0 € y pedir autorización» (#1142) no es la condición «Segundas incluidas en la primera (0 €)»
 * que retiró Dirección el 27/10/2026: es esta segunda concreta, que sigue en su propia línea.
 *
 * #1206 · La otra excepción es del servicio: si su ficha tiene activado «Segundas incluidas en la
 * primera», se ofrece «Incluida en la primera» y la promesa devuelve `{ segundaIncluida: true }`. Si no,
 * ese botón no se dibuja (§9) y el aviso dice quién lo activa y dónde. El servicio se lee al abrir, sin
 * caché: si lo acaban de cambiar, manda lo último. La API lo vuelve a mirar en el maestro al guardar.
 *
 * Las dos salidas conviven y ninguna sustituye a la otra: el aviso no se abre hasta saber si alguna ya
 * resuelve la línea sin preguntar (autorizada, cliente interno o ya incluida por su servicio).
 */
/**
 * La línea del documento de la que el editor hizo la copia que se está avisando (`contexto.original`),
 * si es esa misma línea: mismo número y mismo servicio. Si en el editor se le ha cambiado el servicio,
 * lo pedido es otra segunda y la línea guardada no se toca.
 */
function lineaOriginal(contexto, linea) {
  const original = contexto && contexto.original;
  if (!original || !linea || original === linea) return null;
  const servicio = (l) => (l.servicio ? l.servicio.codigo : null);
  return String(original.numero) === String(linea.numero) && servicio(original) === servicio(linea) ? original : null;
}

export default {
  name: 'segunda-a-cero',
  data: function () {
    return {
      abierto: false,
      linea: null,
      donde: '',
      porc: '',
      importe: '',
      propuesta: null,
      resolver: null,
      contexto: null,
      estado: null,
      cargando: false,
      errorEstado: '',
      pidiendo: false,
      motivoPeticion: '',
      enviando: false,
      enviada: false,
      errorPeticion: '',
      // null mientras se lee la ficha del servicio; después, si permite dejar la segunda incluida (#1206).
      incluible: false,
      // Cuántas veces se ha abierto. Las respuestas de la API llegan tarde, y la de una apertura
      // anterior —otra línea, si se cerró el aviso mientras se enviaba— no puede escribir en esta.
      apertura: 0
    };
  },
  computed: {
    // Lo que se puede hacer sin esperar la autorización: si el servicio la incluye (#1206), también eso.
    salidaSinAutorizacion: function () {
      return this.incluible ? 'déjala incluida en la primera o pon precio a la segunda' : 'pon precio a la segunda';
    },
    contextoValido: function () {
      return !!(this.contexto && this.contexto.documento && this.contexto.id);
    },
    situacion: function () {
      return this.estado ? this.estado.situacion : '';
    },
    solicitud: function () {
      return this.estado ? this.estado.solicitud : null;
    },
    sePuedePedir: function () {
      return this.contextoValido && !this.cargando && !!this.estado && !!this.estado.sePuedePedir;
    },
    quienAutoriza: function () {
      return (this.estado && this.estado.autorizadores) || AUTORIZADORES_POR_DEFECTO;
    },
    dondeSeResuelve: function () {
      return (this.estado && this.estado.dondeSeResuelve) || 'Cuadro de mandos › FACTURACIÓN › OEE · Autorizaciones';
    },
    porQueNoSePideSinDocumento: function () {
      return ' Se pide para una línea de una oferta o un pedido ya guardados, y esta oferta todavía no lo está:'
        + ' guárdala sin esta línea, añádela después y aquí te saldrá el botón «Dejar a 0 € y pedir autorización».';
    },
    lineaTexto: function () {
      const l = this.linea || {};
      const servicio = l.servicio ? (l.servicio.nombre || l.servicio.userText || l.servicio.codigo || '') : '';
      const numero = l.numero !== undefined && l.numero !== null && l.numero !== '' ? 'Línea ' + l.numero : 'Línea nueva';
      return servicio ? numero + ' · ' + servicio : numero;
    },
    motivo: function () {
      return motivoACero(this.linea) || 'No tiene porcentaje ni importe de segunda';
    },
    bloqueado: function () {
      return !!(this.linea && this.linea.blocPorcSegundas);
    },
    minimo: function () {
      const m = this.linea ? parseFloat(this.linea.porcMinSegunda) : NaN;
      return isNaN(m) ? 0 : m;
    },
    motivoNoSigue: function () {
      const p = parseFloat(this.porc);
      const i = parseFloat(this.importe);
      // Lo que no arregla ningún precio se dice antes: si no, «Poner precio» cerraría el aviso con la
      // segunda todavía a 0 €.
      if (descuentoTotal(this.linea)) {
        return 'Con el descuento de la línea al ' + parseFloat(this.linea.porcDescuento) + ' % la segunda sale a 0 € aunque le pongas precio: '
          + 'quien edita la línea tiene que bajar ese descuento, en «Editar Línea» de la oferta o del pedido.';
      }
      if (!(p > 0) && !(i > 0)) return 'Escribe el % de la primera o un importe fijo mayor que 0 para seguir.';
      if (p > 0 && !(parseFloat(this.linea && this.linea.precioUnitario) > 0)) {
        return 'La primera de esta línea está a 0 €, así que un % de ella también da 0 €: pon un importe fijo.';
      }
      if (p > 0 && this.minimo > 0 && p < this.minimo) return 'El % de segunda de este servicio no puede bajar del ' + this.minimo + ' %.';
      // El precio escrito pasa por la misma cuenta que la línea: con un descuento alto, un precio
      // pequeño se queda en 0 € y la API lo devolvería otra vez.
      const conPrecio = Object.assign({}, this.linea, p > 0 ? { porcSegunda: p, importeSegunda: null } : { porcSegunda: 0, importeSegunda: i });
      const sigueACero = motivoACero(conPrecio);
      if (sigueACero) {
        return 'Con ese precio la segunda sigue saliendo a 0 € (' + sigueACero.charAt(0).toLowerCase() + sigueACero.slice(1) + '): súbelo'
          + (parseFloat(this.linea.porcDescuento) > 0 ? ' o baja el descuento en «Editar Línea» de la oferta o del pedido.' : '.');
      }
      return '';
    }
  },
  mounted: function () {
    this.subirALaRaiz();
  },
  beforeDestroy: function () {
    // Fuera de su página, al destruirla nadie más lo quitaría de la raíz.
    if (this.$el.parentNode) this.$el.parentNode.removeChild(this.$el);
  },
  methods: {
    /**
     * El aviso se abre con un popup («Añadir Línea», crear pedido) y la espera del guardado puestos,
     * y Framework7 lleva los dos a la raíz de la aplicación. Dentro de la página quedaba por debajo
     * de ellos aunque su z-index fuera mayor: solo se veía la espera y el guardado no terminaba nunca
     * (prueba de JJCS en preview-3, 30/10/2026). En la raíz y después de ellos, queda encima.
     */
    subirALaRaiz: function () {
      const raiz = this.$f7 && this.$f7.root ? this.$f7.root[0] : document.body;
      if (raiz && this.$el.parentNode !== raiz) raiz.appendChild(this.$el);
    },
    pedir: function (linea, donde, contexto) {
      const self = this;
      // Quien abrió la anterior y aún espera respuesta la da por cancelada, en vez de quedarse colgado.
      if (self.resolver) self.cerrar(null);
      const esta = ++self.apertura;
      self.subirALaRaiz();
      self.linea = linea;
      self.donde = donde || '';
      self.contexto = contexto || null;
      self.estado = null;
      self.errorEstado = '';
      self.pidiendo = false;
      self.motivoPeticion = '';
      self.enviada = false;
      self.enviando = false;
      self.cargando = false;
      self.errorPeticion = '';
      self.propuesta = propuestaDe(linea);
      self.porc = '';
      self.importe = '';
      // Un % no vale si el % está bloqueado o si la primera está a 0 €: no se propone lo que no se acepta.
      const porcUtil = !self.bloqueado && parseFloat(linea && linea.precioUnitario) > 0;
      if (self.propuesta && self.propuesta.porcSegunda && porcUtil) self.porc = String(self.propuesta.porcSegunda);
      else if (self.propuesta && self.propuesta.importeSegunda) self.importe = String(self.propuesta.importeSegunda);
      else if (self.propuesta && self.propuesta.porcSegunda) self.propuesta = null;
      const idServicio = linea && linea.servicio ? linea.servicio.id : null;
      self.incluible = idServicio ? null : false;
      return new Promise(function (resolve) {
        self.resolver = resolve;
        // Ya autorizada para su servicio (la heredó el pedido de su oferta, o ya se guardó así).
        if (autorizadaEnLinea(linea, self.contexto)) {
          self.cerrar({ aCero: true });
          return;
        }
        // Lo que puede resolver la línea sin preguntar se mira antes de enseñar nada: la cola (#1142)
        // si la línea es de un documento guardado, y la ficha del servicio (#1206) si la línea ya se
        // dejó incluida. Mientras falte alguna, el aviso no se abre.
        const conCola = self.contextoValido && linea != null && linea.numero !== undefined && linea.numero !== null && linea.numero !== '';
        const conFicha = !!(idServicio && linea.segundaIncluida);
        const pendientes = { cola: conCola, ficha: conFicha };
        const abrirSiYa = function () {
          if (esta !== self.apertura || !self.resolver) return;
          if (!pendientes.cola && !pendientes.ficha) self.abierto = true;
        };
        if (idServicio) {
          Servicio.get({ itemId: idServicio }).then(function (serv) {
            return !!(serv && serv.segundasIncluidas);
          }).catch(function () {
            // Sin poder leer la ficha no se ofrece: la API tampoco lo dejaría pasar sin ella.
            return false;
          }).then(function (incluye) {
            if (esta !== self.apertura || !self.resolver) return;
            self.incluible = incluye;
            // Una línea que ya se dejó incluida no vuelve a preguntar si su servicio lo sigue permitiendo.
            if (incluye && linea.segundaIncluida) {
              self.cerrar({ segundaIncluida: true });
              return;
            }
            pendientes.ficha = false;
            abrirSiYa();
          });
        }
        if (!conCola) {
          abrirSiYa();
          return;
        }
        // Si ya está autorizada o el cliente es interno, no hay aviso que dar.
        self.cargando = true;
        Autorizaciones.estadoSegundaACero(self.contexto.documento, self.contexto.id, linea.numero,
          linea.servicio ? linea.servicio.codigo : null, linea.claveSegundaACero)
          .then(function (estado) {
            if (esta !== self.apertura || !self.resolver) return;
            self.estado = estado;
            if (estado && (estado.exenta || estado.situacion == 'AUTORIZADA')) {
              self.cerrar({ aCero: true });
              return;
            }
            pendientes.cola = false;
            abrirSiYa();
          })
          .catch(function (e) {
            if (esta !== self.apertura || !self.resolver) return;
            self.errorEstado = (e && (e.message || e.error)) || 'error desconocido';
            pendientes.cola = false;
            abrirSiYa();
          })
          .finally(function () {
            if (esta === self.apertura) self.cargando = false;
          });
      });
    },
    dejarIncluida: function () {
      if (this.incluible) this.cerrar({ segundaIncluida: true });
    },
    empezarPeticion: function () {
      this.pidiendo = true;
      this.errorPeticion = '';
    },
    enviarPeticion: function () {
      const self = this;
      const motivo = self.motivoPeticion.trim();
      if (!motivo || self.enviando) return;
      const esta = self.apertura;
      // Las líneas a las que va la clave se fijan al pedir, no al responder: si entretanto se cierra el
      // aviso o se abre el de otra línea, la clave sigue siendo de ésta y no de la que esté a la vista.
      const linea = self.linea;
      const original = lineaOriginal(self.contexto, linea);
      self.enviando = true;
      self.errorPeticion = '';
      Autorizaciones.pedirSegundaACero(self.contexto.documento, self.contexto.id, lineaParaPedir(linea), motivo)
        .then(function (estado) {
          // La línea guarda la clave que le ha dado la API: el guardado solo aplica la autorización
          // a la línea que la lleva, no a otra que tome su número si esta se quita. También la del
          // documento de la que el editor hizo su copia: al cancelar, la copia se descarta, y al volver
          // a editar la línea tiene que seguir siendo la de la solicitud.
          if (estado && estado.claveLinea) {
            if (linea) self.$set(linea, 'claveSegundaACero', estado.claveLinea);
            if (original) self.$set(original, 'claveSegundaACero', estado.claveLinea);
          }
          if (esta !== self.apertura) return;
          self.estado = estado;
          self.pidiendo = false;
          self.enviada = true;
        })
        .catch(function (e) {
          if (esta !== self.apertura) return;
          self.errorPeticion = (e && (e.message || e.error)) || 'No se ha podido enviar la solicitud.';
        })
        .finally(function () {
          if (esta === self.apertura) self.enviando = false;
        });
    },
    fecha: function (f) {
      if (!f) return '';
      const d = new Date(f);
      return isNaN(d.getTime()) ? '' : d.toLocaleDateString('es-ES') + ' ' + d.toLocaleTimeString('es-ES', { hour: '2-digit', minute: '2-digit' });
    },
    // Uno u otro, como en la línea: con los dos, la segunda saldría del % y el importe se perdería.
    alEscribirPorc: function (v) {
      this.porc = v;
      if (parseFloat(v) > 0) this.importe = '';
    },
    alEscribirImporte: function (v) {
      this.importe = v;
      if (parseFloat(v) > 0) this.porc = '';
    },
    ponerPrecio: function () {
      if (this.motivoNoSigue) return;
      const p = parseFloat(this.porc);
      this.cerrar(p > 0 ? { porcSegunda: p } : { importeSegunda: parseFloat(this.importe) });
    },
    cancelar: function () {
      this.cerrar(null);
    },
    cerrar: function (resultado) {
      const resolver = this.resolver;
      this.abierto = false;
      this.resolver = null;
      if (resolver) resolver(resultado);
    }
  }
};
</script>

<style scoped>
/* Por encima de la espera de guardado del formulario, que sigue puesta mientras se decide: Framework7
   pone su fondo transparente a 14000, que se come los clics, y el indicador a 14500. */
.s0-fondo { position: fixed; inset: 0; z-index: 15000; background: rgba(20, 22, 48, 0.35); display: flex; align-items: center; justify-content: center; }
.s0-tarjeta { background: #fff; border-radius: 12px; box-shadow: 0 10px 30px rgba(0, 0, 0, 0.18); width: 440px; max-width: calc(100vw - 32px); padding: 20px; box-sizing: border-box; color: #1c1c3a; }
.s0-donde { font-size: 11px; letter-spacing: 0.06em; text-transform: uppercase; color: #565a85; margin-bottom: 10px; }
.s0-titulo { margin: 0 0 10px; font-size: 17px; font-weight: 600; }
.s0-texto { margin: 0 0 14px; font-size: 13px; line-height: 1.45; }
.s0-campos { display: flex; gap: 10px; }
.s0-campo { flex: 1; display: flex; flex-direction: column; gap: 4px; font-size: 12px; color: #565a85; }
.s0-campo input { height: 36px; border: 1px solid #c4c6e4; border-radius: 6px; padding: 0 10px; font-size: 14px; font-family: inherit; color: #1c1c3a; box-sizing: border-box; width: 100%; }
.s0-campo input:disabled { background: #f2f2f7; }
.s0-pista { font-size: 11px; color: #565a85; margin-top: 4px; }
.s0-aviso { margin-top: 12px; padding: 8px 10px; border-radius: 6px; border-left: 4px solid #c79a1b; background: #fff7dc; color: #6b5000; font-size: 12px; line-height: 1.4; }
.s0-aviso-incluible { border-left-color: #1a6b52; background: #e8f5ef; color: #14523f; }
.s0-botones { display: flex; justify-content: flex-end; flex-wrap: wrap; gap: 10px; margin-top: 16px; }
.s0-boton { height: 36px; padding: 0 14px; border-radius: 6px; border: 1px solid #c4c6e4; background: #fff; color: #1c1c3a; font-size: 13px; font-weight: 600; font-family: inherit; cursor: pointer; white-space: nowrap; }
.s0-boton-ok { background: #1a6b52; border-color: #1a6b52; color: #fff; }
.s0-boton-ok:disabled { background: #c8cbe0; border-color: #c8cbe0; cursor: default; }
.s0-motivo { text-align: right; font-size: 11px; color: #565a85; margin-top: 6px; }
.s0-boton-pedir { background: #fff7dc; border-color: #c79a1b; color: #6b5000; }
.s0-boton-pedir:disabled { background: #f2f2f7; border-color: #c8cbe0; color: #8a8db0; cursor: default; }
.s0-pedir { margin-top: 12px; }
.s0-pedir textarea { border: 1px solid #c4c6e4; border-radius: 6px; padding: 6px 10px; font-size: 13px; font-family: inherit; color: #1c1c3a; box-sizing: border-box; width: 100%; resize: vertical; }
.s0-error { margin-top: 6px; font-size: 12px; color: #a33b1b; }
.s0-enviada { margin-top: 10px; padding: 8px 10px; border-radius: 6px; border-left: 4px solid #1a6b52; background: #e8f4ef; color: #1a4d3c; font-size: 12px; line-height: 1.4; }
</style>
